/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesDefinitions {
    getFixupPrototypeFunction() { return KubernetesDefinitions.fixupPrototype; }

    static newInstance(model: Partial<KubernetesDefinitions>): KubernetesDefinitions {
        let obj = Object.assign(new KubernetesDefinitions(), model);
        KubernetesDefinitions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesDefinitions>): KubernetesDefinitions {
        if (!model) return null;
        return KubernetesDefinitions.newInstance(<KubernetesDefinitions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesDefinitions) {
        if (!obj) return;

        models.KubernetesDefinitions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesDefinitions): boolean {
        Object.setPrototypeOf(obj, KubernetesDefinitions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Kubernetes Resource types
     */
    resource_type: models.KubernetesResourceType;

    /**
     * Kubernetes Utilization Type
     */
    utilization_type: models.KubernetesUtilizationType;

    /**
     * Kubernetes workloads
     */
    workload: models.KubernetesWorkload;

    /**
     * Kubernetes cluster infra component
     */
    cluster_component: models.KubernetesInClusterComponent;

}
